export default __webpack_public_path__ + "static/21-1407a4074e626b55f13627bdf95db6d6.jpg";